import React, { Component } from 'react';
import PropTypes from 'prop-types';
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    if (error instanceof DOMException) return {
      hasError: false
    };
    return {
      hasError: true
    };
  }
  async componentDidCatch(data) {
    const {
      app
    } = this.props;
    app.events.emit('monitor:log', {
      error: data
    });
  }
  render() {
    const {
      props: {
        children
      },
      state: {
        hasError
      }
    } = this;
    if (hasError) {
      return /*#__PURE__*/React.createElement("p", null, "Error");
    }
    return children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]).isRequired,
  app: PropTypes.object.isRequired
};
export default ErrorBoundary;
//# sourceMappingURL=index.js.map